export class CountdownSettingsViewModel {
  countdownTitle: string;
  countdownDate: string;
}
